import { User } from './User';
import { Zond } from './Zond';

export type CompanyType = 'individual' | 'legal';

export class Company {
    id: number = 0;
    created_at: string = '';
    name: string = '';
    phone?: string = undefined;
    address?: string = undefined;
    description?: string = undefined;
    location_region_id?: number;
    users: User[] = [];
    zonds: Zond[] = [];

    // Тип аккаунта: individual (по умолчанию) или legal.
    company_type: CompanyType = 'individual';

    // Реквизиты юрлица (заполняются, когда company_type = 'legal').
    inn?: string = undefined;
    kpp?: string = undefined;
    bank_name?: string = undefined;
    account?: string = undefined;
    corr_account?: string = undefined;
    bik?: string = undefined;
    legal_address?: string = undefined;
    postal_address?: string = undefined;
    accounting_email?: string = undefined;
    contact_name?: string = undefined;
    contact_email?: string = undefined;
}
